import { FC, Suspense } from "react";
import { Route, Routes } from "react-router-dom";

import { ErrorBoundary } from "common/components";
import { Login } from "modules/_shared/pages";
import { ROUTES } from "common/config";

const GuestLayout: FC = () => {
  return (
    <>
      <main className="app-guest-layout">
        <Suspense
          fallback={
            <>
              <div>Fallback</div>
            </>
          }
        >
          <ErrorBoundary>
            <Routes>
              <Route path={ROUTES.DEFAULT} element={<Login />} />
              <Route path={ROUTES.WILD} element={<Login />} />
            </Routes>
          </ErrorBoundary>
        </Suspense>
      </main>
    </>
  );
};

export default GuestLayout;
